const platformWidget = (isResize = false) => {
  document.querySelectorAll('.platform').forEach((widget) => {
    const windowWidth = window.innerWidth;
    const svg = document.getElementById('Infographic');
    const steps = widget.querySelectorAll('.platform .platform__step');
    const maxSteps = steps.length;
    const prevArrow = widget.querySelector('.arrow-left');
    const nextArrow = widget.querySelector('.arrow-right');

    if (windowWidth >= 1025) {
      steps.forEach((step, index) => {
        step.addEventListener('mouseenter', () => {
          step.classList.add('is-active');
          const i = parseInt(index) + 1;
          svg.classList.add('state-' + i);
        });

        step.addEventListener('mouseleave', () => {
          step.classList.remove('is-active');
          const i = parseInt(index) + 1;
          svg.classList.remove('state-' + i);
          svg.classList.add('r-state-' + i);
          setTimeout(() => svg.classList.remove('r-state-' + i), 300);
        });
      });
    } else {
      svg.classList.add('state-1');
      nextArrow.onclick = () => nextSlide();
      prevArrow.onclick = () => prevSlide();
      if (!isResize) {
        widget.addEventListener('swiped-left', nextSlide);
        widget.addEventListener('swiped-right', prevSlide);
      }
    }

    const currentIndex = () => {
      return [...steps].findIndex((step) => step.classList.contains('visible'));
    };

    function prevSlide() {
      const index = currentIndex();
      const i = index + 1;
      steps.forEach((step) => step.classList.remove('visible'));
      if (i === 1) {
        steps[maxSteps - 1].classList.add('visible');
        svg.classList.remove('state-' + i);
        svg.classList.add('r-state-' + i);
        setTimeout(() => svg.classList.remove('r-state-' + i), 300);
        svg.classList.add('state-' + maxSteps);
      } else {
        steps[index - 1].classList.add('visible');
        svg.classList.remove('state-' + i);
        svg.classList.add('r-state-' + i);
        setTimeout(() => svg.classList.remove('r-state-' + i), 300);
        svg.classList.add('state-' + index);
      }
    }

    function nextSlide() {
      const index = currentIndex();
      const i = index + 1;
      steps.forEach((step) => step.classList.remove('visible'));
      if (i === maxSteps) {
        steps[0].classList.add('visible');
        svg.classList.remove('state-' + i);
        svg.classList.add('r-state-' + i);
        setTimeout(() => svg.classList.remove('r-state-' + i), 300);
        svg.classList.add('state-' + 1);
      } else {
        steps[i].classList.add('visible');
        svg.classList.remove('state-' + i);
        svg.classList.add('r-state-' + i);
        setTimeout(() => svg.classList.remove('r-state-' + i), 300);
        const nextState = i + 1;
        svg.classList.add('state-' + nextState);
      }
    }
  });
};

document.addEventListener('DOMContentLoaded', () => {
  platformWidget();
});

window.addEventListener('resize', () => {
  platformWidget(true);
});
